import { render, staticRenderFns } from "./LightReadingDailyAdd.vue?vue&type=template&id=6e6e2542&scoped=true&"
import script from "./LightReadingDailyAdd.vue?vue&type=script&lang=js&"
export * from "./LightReadingDailyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6e2542",
  null
  
)

export default component.exports